// src/components/layout/MainLayout.jsx
import ChatBot from "./components/chatbot/ChatBot";
import FooterOne from "./components/FooterOne";
import Navbar from "./components/Navbar";
import SmoothScroll from "./helper/SmoothScroll";

const MainLayout = ({ children }) => {
  return (
    <>
      <SmoothScroll />
      <Navbar />
      <ChatBot />
      <main id="main-content" tabIndex={-1}>
        {children}
      </main>
      <FooterOne />
    </>
  );
};

export default MainLayout;
